import { AxiosError } from 'axios'
import { UseMutationOptions, useMutation } from 'react-query'

import { projectsApi } from '../projects.api'
import { FormValuesProjectRequest } from '../projects.types'
import { getPartsForFormattedRequest } from '../projects.utils'
import { useUploadProjectImages } from '../use-upload-project-images'
import { useLocale } from '@plandi/common'

export const useMutationUpdateProject = (
  projectId?: number,
  options?: UseMutationOptions<unknown, AxiosError, FormValuesProjectRequest>
) => {
  const getProjectImages = useUploadProjectImages()
  const locale = useLocale()

  const mutation = useMutation(
    async (requestBody) => {
      if (projectId) {
        const { coverId, imagesId } = await getProjectImages({
          projectId,
          cover: requestBody.cover,
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          images: requestBody.images
        })

        return projectsApi.updateProject(
          projectId,
          {
            ...requestBody,
            parts: getPartsForFormattedRequest(requestBody.parts),
            coverId,
            images: imagesId
          },
          locale
        )
      }
    },
    {
      ...options
    }
  )

  return mutation
}
